import React, { useEffect } from 'react';
import { Col, Row } from 'react-grid-system';
import { useForm } from 'react-hook-form';

const EmailContactInputs = ({
  count,
  index,
  remove,
  setValue,
}): JSX.Element => {
  const { 
    formState: { errors },
    register,
    watch,
  } = useForm();
  const fieldPrefix = `contacts.${index}`;

  useEffect(() => {
    watch((data, { name }) => {
      // Use setValue instead of update to prevent component reload
      setValue(`${fieldPrefix}.${name}`, data[name]);
    });
  }, []);

  return (
    <Row align="center" className="mt-2 mb-2">
      <Col sm={5}>
        <label className="flex-column mb-4">
          <span className="f-sans block mb-2">
            Full Name
          </span>
          <input
            className="block"
            {...register('name', {
              required: 'A full name is required.',
              pattern: {
                value: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g,
                message: 'Only letters, spaces, and some punctuation are accepted.',
              },
              minLength: {
                // Assumes a full name must have at least one letter in the first and last names
                value: 3,
                message: 'Please enter your full name.'
              },
            })} />
        </label>
        {
          errors.name &&
            <p className="f-medium">{errors.name.message.toString()}</p>
        }
      </Col>
      <Col sm={5}>
        <label className="flex-column mb-4">
          <span className="f-sans block mb-2">
            Email
          </span>
          <input
            className="block"
            {
              ...register(
                ('email'),
                {
                  required: 'An email is required.',
                  pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: 'Value entered does not match email format (e.g. address@domain.io).',
                  },
                }
              )
            } />
        </label>
        {
          errors.email &&
            <p className="f-medium">{errors.email.message.toString()}</p>
        }
      </Col>
      {
        (count > 1) && 
          <Col sm={2}>
            <button className="bare mt-2" onClick={() => { remove(index); }}>
              Remove
            </button>
          </Col>
      }
    </Row>
  );
};

export default EmailContactInputs;
